<p-toast></p-toast>
<div *ngIf="!viewChallan" class="app-farmers-challan">
    <p-card styleClass="p-card-shadow">
        <!-- <h5 class="mt-0">Farmer Application Details</h5> -->
        <div class="card">
            <p-table #appFarmerChallanTable [value]="appFarmerChallanModel" [(selection)]="selectedApplications"
                dataKey="AppId_ProgID" (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" [rows]="10"
                [paginator]="true"
                [globalFilterFields]="['AppId','FarmerId','ProgID','ProgrammeName', 'Block', 'District', 'Village', 'VendorName', 'AppUserType', 'ChallanStatus', 'MIArea', 'FarmerShare']"
                responsiveLayout="scroll" [rowHover]="true"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'FARMER_APPLICATION_FOR_BANK_CHALLAN'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="appFarmerChallanTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="AppId">{{'APP_ID'| translate}}
                            <p-columnFilter type="text" field="AppId" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppId"></p-sortIcon>
                        </th>
                        <th pSortableColumn="VendorName">{{'VENDOR_NAME'| translate}}
                            <p-columnFilter type="text" field="VendorName" display="menu"></p-columnFilter>
                            <p-sortIcon field="VendorName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ProgrammeName">{{'PROGRAMME_NAME'| translate}}
                            <p-columnFilter type="text" field="ProgrammeName" display="menu"></p-columnFilter>
                            <p-sortIcon field="ProgrammeName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="AppUserType">{{'APP_USER_TYPE'| translate}}
                            <p-columnFilter type="text" field="AppUserType" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppUserType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="MIArea">{{'MI_AREA'| translate}}
                            <p-columnFilter type="text" field="MIArea" display="menu"></p-columnFilter>
                            <p-sortIcon field="MIArea"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FarmerShare">{{'FARMER_SHARE'| translate}}
                            <p-columnFilter type="text" field="FarmerShare" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerShare"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                            <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                            <p-sortIcon field="Village"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Block">{{'BLOCK'| translate}}
                            <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                            <p-sortIcon field="Block"></p-sortIcon>
                        </th>
                        <th pSortableColumn="District">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ChallanStatus">{{'CHALLAN_STATUS'| translate}}
                            <p-columnFilter type="text" field="ChallanStatus" display="menu"></p-columnFilter>
                            <p-sortIcon field="ChallanStatus"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="product"></p-tableCheckbox>
                        </td>
                        <td>{{product.AppId}}</td>
                        <td>{{product.VendorName}}</td>
                        <td>{{product.ProgrammeName}}</td>
                        <td>{{product.AppUserType}}</td>
                        <td>{{product.MIArea}}</td>
                        <td>{{product.FarmerShare}}</td>
                        <td>{{product.Village}}</td>
                        <td>{{product.Block}}</td>
                        <td>{{product.District}}</td>
                        <td>{{product.ChallanStatus}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="justify-content-end">
                        <button pButton type="button" label="{{'GENERATE_CHALLAN'| translate}}" class="p-button-primary"
                            (click)="printChallan()"></button>
                    </div>
                </ng-template>
            </p-table>
        </div>
        <div class="card" *ngIf="selectedApplications.length">
            <h5><b>{{'TOTAL_NO_OF_APPLICATIONS_SELECTED_FOR_BANK_CHALLAN'| translate}}: {{ selectedApplications.length }}</b></h5>
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-4">
                    <p>{{'TOTAL_FARMER_SHARE_AMOUNT'| translate}}: {{ totalFarmerShareAmount }}</p>
                </div>
            </div>
            <div class="flex justify-content-end">
                <button (click)="menu.toggle($event)" pButton pRipple p-button-info label="{{'DOWNLOAD_SELECTED_DATA'| translate}}" icon="pi pi-upload"></button>
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </div>
            
            <!-- <div class="card">
                <p-toolbar>
                        <ng-template pTemplate="left">
    
                        </ng-template>
                        <ng-template pTemplate="right">
                            <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea required
                                rows="3" cols="20" class="mr-3"></textarea>
                            <button pButton pRipple label="Submit" (click)="onSubmit()" class="p-button-help"></button>
                        </ng-template>
                </p-toolbar>
            </div> -->
        </div>
    </p-card>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>

<div *ngIf="viewChallan" class="app-farmers-challan">
    <div class="card">
        <div class="flex justify-content-around">
            <button pButton pRipple icon="pi pi-print" type="submit" label="{{'PRINT_ALL_CHALLAN'| translate}}"
                (click)="onPrint('printableArea')"></button>

            <button pButton pRipple type="button" class="p-button-secondary" label="BACK" 
            (click)="onBack()"></button>
        </div>
    </div>
    <div class="card">
        <div class="col-12">
            <div class="flex justify-content-center">
                <h4>{{'FARMER_SHARE_CHALLAN'| translate}}</h4>
            </div>

            <div id="printableArea">
                <div *ngFor="let challanPrintData of challanPrintData; let i = index" class="page-break-after">
                    <div class="p-fluid p-formgrid grid">
                        <!-- bank copy -->
                        <div class="field col-12 md:col-6" reflow="true">
                            <div class="flex justify-content-start mb-2">{{ currentDate | date : 'medium'}}</div>
                            <div class="consent-form border">
                                <div class="print border bold" style="margin-top: 1px; text-align: center">
                                    <div class="flex justify-content-center">
                                        <img src="assets/activitiesImages/micada_new_logo.png" alt="footer sections" width="100" height="40"
                                            class="mr-2">
                                    </div>
                                    <div class="mt-3 headings">
                                        <strong>
                                            {{'MICRO_IRRIGATION_&_COMMAND'| translate}}
                                        </strong>
                                        <br>
                                        <strong> {{'HARYANA'| translate}} </strong><br>
                                        <strong>
                                            {{'FINANCIAL_YEAR_2022'| translate}}
                                        </strong>
                                    </div>
                                </div>
                                <div class="flex justify-content-center mt-1 subheading">
                                    <p>{{'CHALLAN_FOR_PAYMENT_OF_DUE_DATE'| translate}}</p>
                                </div>

                                <!-- personal details start -->
                                <ng-container>
                                    <!-- <div class="flex justify-content-center mt-5">
                            <h5>Personal Details</h5>
                            </div> -->
                                    <div class="table">
                                        <table class="border">
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'MODE_OF_PAYMENT'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.PaymentMode }}</p>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'NAME_OF_APPLICANT'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.ApplicantName | uppercase }}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'CHALLAN_DATE'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.ChallanDate | date:'medium'
                                                        }}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'APPLICATION_NUMBER'| translate}}</p>
                                                </td>

                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.AppId }}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'BENEFICIARY_NAME'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.BeneficiaryName }}</p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </ng-container>

                                <ng-container>
                                    <div class="flex justify-content-center mt-1 subheading">
                                        <p>{{'PAYMENT_DETAILS'| translate}}</p>
                                    </div>
                                    <div class="table">
                                        <table class="border">
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'BENEFICIARY_ACCOUNT_NO'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.BeneficiaryAccountNo }}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'BANK_NAME'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.BankName }}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'BRANCH_NAME'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.BranchName }}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'IFSC_CODE'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.IFSCCODE }}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'AMOUNT_TO_BE_DEPOSITED'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.AmountToBeDeposted }}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'AMOUNT_TO_BE_DEPOSITED_IN_WORDS'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.AmountToBeDepostedInWords }}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                        <div class="flex justify-content-between mb-5 mt-2 px-2">
                                            <div class="bold note mt-4">{{'DEPOSIT_DATE'| translate}}</div>
                                            <div class="bold note mt-4">{{'SIGN_OF_DEPOSITOR'| translate}}</div>
                                        </div>
                                        <div class="flex justify-content-end bold mt-5 pt-5 px-2 note">{{'BANK_RECEIVING_STAMP'| translate}}
                                        </div>

                                    </div>
                                </ng-container>

                                <ng-container>
                                    <div class="border note mt-3">
                                        <div class="flex justify-content-start mt-2 px-4"><b>Note:</b> {{'PLEASE_DONT_MAKE_A_COPY_OF_CHALLAN'| translate}}
                                        </div>
                                        <div class="flex justify-content-start px-4">{{'YOU_CAN_PAY_AT_ANY_BRANCH'| translate}}
                                        </div>
                                        <div class="flex justify-content-start mb-2 px-4">{{'CHALLAN_PAYMENT_NOTE'| translate}}
                                            </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>

                        <!-- customer copy -->
                        <div class="field col-12 md:col-6" reflow="true">
                            <div class="flex justify-content-start mb-2">{{ currentDate | date : 'medium'}}</div>
                            <div class="consent-form border">
                                <div class="print border bold" style="margin-top: 1px; text-align: center">
                                    <div class="flex justify-content-center">
                                        <img src="assets/activitiesImages/micada_new_logo.png" alt="footer sections" width="100" height="40"
                                            class="mr-2">
                                    </div>
                                    <div class="mt-3 headings">
                                        <strong>
                                           {{'MICRO_IRRIGATION_&_COMMAND'| translate}}
                                        </strong>
                                        <br>
                                        <strong> {{'HARYANA'| translate}} </strong><br>
                                        <strong>
                                            {{'FINANCIAL_YEAR_2022-23'| translate}}
                                        </strong>
                                    </div>
                                </div>
                                <div class="flex justify-content-center mt-1 subheading">
                                    <p>{{'CHALLAN_PAYMENT_DUE_AMOUNT_CUSTOMER_COPY'| translate}}</p>
                                </div>

                                <!-- personal details start -->
                                <ng-container>
                                    <!-- <div class="flex justify-content-center mt-5">
                            <h5>Personal Details</h5>
                            </div> -->
                                    <div class="table">
                                        <table class="border">
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'MODE_OF_PAYMENT'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.PaymentMode }}</p>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'NAME_OF_APPLICANT'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.ApplicantName | uppercase }}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'CHALLAN_DATE'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.ChallanDate | date:'medium'
                                                        }}
                                                    </p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'APPLICATION_NUMBER'| translate}}</p>
                                                </td>

                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.AppId }}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'BENEFICIARY_NAME'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.BeneficiaryName }}</p>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </ng-container>

                                <ng-container>
                                    <div class="flex justify-content-center mt-1 subheading">
                                        <p>{{'PAYMENT_DETAILS'| translate}}</p>
                                    </div>
                                    <div class="table">
                                        <table class="border">
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'BENEFICIARY_ACCOUNT_NO'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.BeneficiaryAccountNo }}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'BANK_NAME'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.BankName }}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'BRANCH_NAME'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.BranchName }}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'IFSC_CODE'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.IFSCCODE }}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'AMOUNT_TO_BE_DEPOSITED'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.AmountToBeDeposted }}</p>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <p class="bold col-12">{{'AMOUNT_TO_BE_DEPOSITED_IN_WORDS'| translate}}</p>
                                                </td>
                                                <td>
                                                    <p class="col-12">{{ challanPrintData?.AmountToBeDepostedInWords }}
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                        <div class="flex justify-content-between mb-5 mt-2 px-2">
                                            <div class="bold note mt-4">{{'DEPOSIT_DATE'| translate}}</div>
                                            <div class="bold note mt-4">{{'SIGN_OF_DEPOSITOR'| translate}}</div>
                                        </div>
                                        <div class="flex justify-content-end bold mt-5 pt-5 px-2 note">{{'BANK_RECEIVING_STAMP'| translate}}
                                        </div>

                                    </div>
                                </ng-container>

                                <ng-container>
                                    <div class="border note mt-3">
                                        <div class="flex justify-content-start mt-2 px-4"><b>{{'NOTE'| translate}}:</b> {{'PLEASE_DONT_MAKE_A_COPY_OF_CHALLAN'| translate}}.
                                        </div>
                                        <div class="flex justify-content-start px-4">{{'YOU_CAN_PAY_AT_ANY_BRANCH'| translate}}.
                                            
                                        </div>
                                        <div class="flex justify-content-start mb-2 px-4">{{'CHALLAN_PAYMENT_NOTE'| translate}}.
                                           </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                    <div class="hidden-print">
                        <hr>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>